module.exports = __webpack_public_path__ + "img/15d6d9a.jpg";